import * as axios from 'axios';
import * as _ from 'lodash';
import {API_CONFIG} from "../../config/api";
import {Auth} from "./Auth";
import UserService from "../../apiServices/UserService";

const defaultConfig = {
    baseURL: API_CONFIG.BASE_URL,
    timeout: 30000,
    headers: {
        "Content-Type": "application/json",
    }
};

const API_METHOD = {
    POST: "post",
    GET: "get",
    PUT: "put",
    PATCH: "patch",
    DELETE: "delete"
};

axios.interceptors.response.use(function (response) {
    // Do something with response data
    if(response.data.code === 0) {
        return response.data;
    } else {
        var message;
        for (var key in response.data.message){
            if(Array.isArray(response.data.message[key]))
                message = response.data.message[key].join(',');
            else
                message = response.data.message[key];
        }
        var responseData = response.data;
        responseData.mgs = message;
        return responseData;
    }
}, function (error) {
    const status = _.get(error.response, 'status');

    if(status === 401) {
        if(error.response.data.code !== 0) {
            UserService.refreshToken(Auth.getToken())
                .then(response => {
                    Auth.setToken(response.data.data.token);
                });
        } else {
            UserService.logout();
            window.location.href = "/login";
        }
    } else {
        return Promise.reject(error);
    }
});

class Api {

    request = (config) => {
        return axios(config);
    };

    get = (url, config = {}) => {
        config = _.merge(defaultConfig, config);
        config.method = API_METHOD.GET;
        config.headers = {
            "Authorization": 'Bearer '+Auth.getToken(),
        };
        config.url = url;
        return this.request(config);
    };

    post = (url, data, config = {}) => {
        config = _.merge(defaultConfig, config);
        config.method = API_METHOD.POST;
        config.headers = {
            "Authorization": 'Bearer '+Auth.getToken(),
        };
        config.url = url;
        config.data = data;
        return this.request(config);
    };

    postForm = (url, data, config = {}) => {
        const dConfig = _.merge(defaultConfig, {headers: {'Content-Type': 'multipart/form-data'}});
        config = _.merge(dConfig, config);
        config.method = API_METHOD.POST;
        config.url = url;
        config.data = data;
        return this.request(config);
    };

    put = (url, data, config = {}) => {
        config = _.merge(defaultConfig, config);
        config.method = API_METHOD.PUT;
        config.url = url;
        config.data = data;
        config.headers = {
            "Authorization": 'Bearer '+Auth.getToken(),
        };
        return this.request(config);
    };

    patch = (url, data, config = {}) => {
        config = _.merge(defaultConfig, config);
        config.method = API_METHOD.PATCH;
        config.headers = {
            "Authorization": 'Bearer '+Auth.getToken(),
        };
        config.url = url;
        config.data = data;
        return this.request(config);
    };

    delete = (url, config = {}) => {
        config = _.merge(defaultConfig, config);
        config.method = API_METHOD.DELETE;
        config.headers = {
            "Authorization": 'Bearer '+Auth.getToken(),
        };
        config.url = url;
        return this.request(config);
    };
}

const apiClient = new Api();

export {API_METHOD, apiClient};